/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EdictDocumentResponse
 */
export interface EdictDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof EdictDocumentResponse
     */
    address: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictDocumentResponse
     */
    court: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictDocumentResponse
     */
    fileNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof EdictDocumentResponse
     */
    content: string;
}

/**
 * Check if a given object implements the EdictDocumentResponse interface.
 */
export function instanceOfEdictDocumentResponse(value: object): value is EdictDocumentResponse {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('court' in value) || value['court'] === undefined) return false;
    if (!('fileNumber' in value) || value['fileNumber'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function EdictDocumentResponseFromJSON(json: any): EdictDocumentResponse {
    return EdictDocumentResponseFromJSONTyped(json, false);
}

export function EdictDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdictDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'],
        'court': json['court'],
        'fileNumber': json['fileNumber'],
        'content': json['content'],
    };
}

export function EdictDocumentResponseToJSON(json: any): EdictDocumentResponse {
    return EdictDocumentResponseToJSONTyped(json, false);
}

export function EdictDocumentResponseToJSONTyped(value?: EdictDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'court': value['court'],
        'fileNumber': value['fileNumber'],
        'content': value['content'],
    };
}

